import {useState} from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import {Typography} from '@mui/material';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {number} from 'prop-types';

import {productShape} from '../../../../../proptypes-shapes';
import {calculateTieredPricingDetails} from '../../../../../utils/payment';
import PopperComponent from '../../../../main-sidebar/PopperComponent/PopperComponent';

const ProductPricingInformation = ({product, quantity}) => {
  const [popperAnchorEl, setPopperAnchorEl] = useState(null);
  const [isPopperOpen, setIsPopperOpen] = useState(false);

  const openPopper = e => {
    setPopperAnchorEl(e.currentTarget);
    setIsPopperOpen(true);
  };

  const closePopper = () => {
    setPopperAnchorEl(null);
    setIsPopperOpen(false);
  };

  const {total, breakdown} = calculateTieredPricingDetails(quantity, product.tiers);

  return (
    <div>
      <Grid item onMouseEnter={openPopper} onMouseLeave={closePopper}>
        <InfoOutlinedIcon fontSize="small" sx={{ml: 1, cursor: 'pointer'}} />
      </Grid>

      <PopperComponent placement="bottom" anchorEl={popperAnchorEl} isOpen={isPopperOpen} onClose={() => setIsPopperOpen(false)} hasArrow={false} paperStyle={{ml: 4}}>
        <Typography fontSize={12} fontWeight="bold">
          Coût pour {quantity} unités : {total / 100} €
        </Typography>
        <Box mt={0.5}>
          <ul>
            {breakdown.map((item, index) => (
              <li key={index} style={{fontSize: 11, marginBottom: 2}}>
                {item.units} unité{item.units > 1 ? 's' : ''} × {item.unitAmount / 100} € = {item.subtotal / 100} €
              </li>
            ))}
          </ul>
        </Box>
      </PopperComponent>
    </div>
  );
};

ProductPricingInformation.propTypes = {
  product: productShape.isRequired,
  quantity: number.isRequired
};

export default ProductPricingInformation;
